import { List } from 'immutable';
import { quickbooksCompanyConstants } from '../constants';

export function quickbooks_companies(state = {}, action) {
  switch (action.type) {
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const quickbooksCompanyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (quickbooksCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(quickbooksCompanyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_DELETE_SUCCESS: {
      const { quickbooksCompanyId } = action;

      if (!state.items) {
        return state;
      }

      const quickbooksCompanyIndex = state.items.findIndex(val => val.id == quickbooksCompanyId);

      if (quickbooksCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(quickbooksCompanyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case quickbooksCompanyConstants.QUICKBOOKS_COMPANY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
